<template>
  <section class="wrap_pop">
    <div class="popbox_wrap">
      <div class="popbox_cont">
        <h1 class="pop_tit">개인정보 이용 및 제공동의</h1>
        <div class="cont_agree">
          <div v-if="ccoCd == '1' || ccoCd == '5'">
            <strong class="tit_cont_agree">[SK텔레콤 귀중]</strong>
            <ul class="list_type01">
              <li>
                본인은 SK텔레콤(주)(이하 ‘회사’라 합니다)가 제공하는
                본인확인서비스(이하 ‘서비스’라 합니다)를 이용하기 위해, 다음과
                같이 ‘회사’가 본인의 개인정보를 수집/이용하고, 개인정보의 취급을
                위탁하는 것에 동의합니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>
                1. 수집항목
                <ul class="list_type02">
                  <li>
                    - 이용자의 성명, 이동전화번호, 가입한 이동전화 회사,
                    생년월일, 성별
                  </li>
                  <li>- 연계정보(CI), 중복가입확인정보(DI)</li>
                  <li>
                    - 이용자가 이용하는 웹사이트 또는 Application 정보, 이용일시
                  </li>
                  <li>- 내외국인 여부</li>
                  <li>- 가입한 이동전화회사 및 이동전화브랜드</li>
                </ul>
              </li>
              <li>
                2. 이용목적
                <ul class="list_type02">
                  <li>
                    - 이용자가 웹사이트 또는 Application에 입력한 본인확인정보의
                    정확성 여부 확인(본인확인서비스 제공)
                  </li>
                  <li>
                    - 해당 웹사이트 또는 Application에
                    연계정보(CI)/중복가입확인정보(DI) 전송
                  </li>
                  <li>- 서비스 관련 상담 및 불만 처리 등</li>
                  <li>
                    - 이용 웹사이트/Application 정보 등에 대한 분석 및 세분화를
                    통한, 이용자의 서비스 이용 선호도 분석
                  </li>
                </ul>
              </li>
              <li>
                3. 개인정보의 보유기간 및 이용기간
                <ul class="list_type02">
                  <li>
                    - 이용자가 서비스를 이용하는 기간에 한하여 보유 및 이용.
                    다만, 아래의 경우는 제외
                  </li>
                  <li>
                    - 법령에서 정하는 경우 해당 기간까지 보유(상세 사항은 회사의
                    개인정보취급방침에 기재된 바에 따름)
                  </li>
                </ul>
              </li>
              <li>
                4. 본인확인서비스 제공을 위한 개인정보의 취급위탁
                <ul class="list_type02">
                  <li>
                    - 수탁자 : NICE평가정보(주), (주)다날, (주)드림시큐리티,
                    SCI평가정보(주), NHN한국사이버결제(주), (주)KG모빌리언스,
                    코리아크레딧뷰로(주), 한국모바일인증(주)
                  </li>
                  <li>
                    - 취급위탁 업무 : 본인확인정보의 정확성 여부
                    확인(본인확인서비스 제공), 연계정보(CI)/중복가입확인정보(DI)
                    생성 및 전송, 서비스 관련 상담 및 불만 처리, 휴대폰인증보호
                    서비스, 이용자의 서비스 이용 선호도 분석정보 제공관련 시스템
                    구축·광고매체 연동 및 위탁영업 등
                  </li>
                  <li>
                    ※ 수탁자의 상세 개인정보 취급 위탁 내용은 각 수탁자가 정하는
                    절차와 방법에 따라 수탁자 홈페이지 등에 게시된 수탁자의
                    개인정보 취급방침 및 제3자 제공 동의 방침 등에 따릅니다.
                  </li>
                </ul>
              </li>
              <li>
                5. 위 개인정보 수집·이용 및 취급위탁에 동의하지 않으실 경우,
                서비스를 이용하실 수 없습니다.
              </li>
              <li>
                ※ 회사가 제공하는 서비스와 관련된 개인정보의 취급과 관련된
                사항은, 회사의 개인정보취급방침(회사 홈페이지 www.sktelecom.com
                )에 따릅니다.
              </li>
            </ul>

            <strong class="tit_cont_agree">[NICE평가정보(주) 귀중]</strong>
            <ul class="list_type01">
              <li>
                NICE평가정보(주)(이하 ‘회사’)는 SK텔레콤(주)의 업무를 대행하여
                휴대폰본인확인서비스를 제공함에 있어 고객으로부터 개인정보를
                수집하고 이용하기 위해 ‘정보통신망 이용촉진 및 정보보호에 관한
                법률’에 따라서 다음과 같이 본인의 동의를 받습니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>1. 개인정보의 내용</li>
              <li>
                가. 정보항목
                <ul class="list_type02">
                  <li>
                    - 생년월일, 성명, 성별, 내/외국인 구분, 휴대폰번호, 가입한
                    이동통신사, IP주소
                  </li>
                </ul>
              </li>
              <li>
                나. 수집방법
                <ul class="list_type02">
                  <li>
                    - 본인인증 요청시 회원사 서비스 페이지 또는 본인인증 팝업창
                    페이지에서 이용자가 직접 입력
                  </li>
                  <li>
                    - 본인인증 과정에서 시스템에서 생성되는 정보 수집(Ex.
                    IP주소)
                  </li>
                </ul>
              </li>
              <li>2. 개인정보의 이용목적과 제공정보</li>
              <li>
                가. 이용 목적
                <ul class="list_type02">
                  <li>
                    - 고객의 회원가입, ID/PW찾기, 거래동의 등을 위한 휴대폰
                    본인확인 결과
                  </li>
                  <li>- 휴대폰 소지 확인을 위한 SMS 인증번호 전송</li>
                  <li>- 부정 이용 방지 및 수사의뢰</li>
                  <li>- 휴대폰번호보호서비스 해제(서비스 가입자에 한함)</li>
                  <li>- 기타 법률에서 정한 목적</li>
                </ul>
              </li>
              <li>
                나. 제공하는 개인정보
                <ul class="list_type02">
                  <li>
                    - 성명, 성별, 생년월일, 내/외국인, 휴대폰번호, 이동통신사,
                    IP주소, CI, DI [제공사 : 서비스회원사(업체별 선택 및
                    이용방식에 따라 전부 또는 일부를 제공)]
                  </li>
                  <li>
                    - 성명, 성별, 생년월일, 휴대폰번호, 이동통신사 [제공사 :
                    SKT, KT, LGU+]
                  </li>
                  <li>
                    - 휴대폰번호 [제공사 : SKT, KT, LGU+]
                  </li>
                </ul>
              </li>
              <li>3. 개인정보의 보유 및 이용기간</li>
              <li>
                이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이
                달성되면 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래의
                이유로 명기한 기간 동안 보유합니다.
              </li>
              <li>
                가. 회사 내부 방침에 의한 정보보유 사유 - 본인확인 발생 및
                차단기록, 휴대폰번호
                <ul class="list_type02">
                  <li>- 보유 이유: 부정 이용 방지 및 민원 처리</li>
                  <li>- 보유 기간: 1년</li>
                </ul>
              </li>
              <li>
                나. 관계법령에 의한 정보보유 사유
                <ul class="list_type02">
                  <li>- 이용자 불만 또는 분쟁 처리에 관한 기록</li>
                  <li>
                    - 보유 이유: 전자상거래 등에서의 소비자보호에 관한 법률
                  </li>
                  <li>- 보유 기간: 3년</li>
                </ul>
              </li>
            </ul>
          </div>

          <div v-if="ccoCd == '5'">
            <strong class="tit_cont_agree">[개인정보 제3자 제공 동의]</strong>
            <ul class="list_type01">
              <li>
                "알뜰폰(MVNO)"사업자는 다음과 같이 개인정보를 제3자에게 제공하고
                있습니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>
                제1조 (알뜰폰(MVNO) 사업자)
                <ul class="list_type02">
                  <li>
                    - SK텔레콤의 알뜰폰(MVNO) 사업자는
                    SK텔링크(SK세븐모바일),아이즈비전(아이즈모바일),이마트(이마트알뜰폰),유니컴즈(모빙),LG헬로비전(헬로모바일),토스모바일(주),에스원(안심모바일),큰사람(이야기모바일),스마텔(스마텔),프리텔레콤(프리티),조이텔(조이텔),KCT(티플러스),
                    KB국민은행(Liiv M)입니다.
                  </li>
                </ul>
              </li>
              <li>
                제2조 (제공목적)
                <ul class="list_type02">
                  <li>
                    - 본 동의는 본인확인서비스를 제공하기 위하여 본인확인기관인
                    SK텔레콤과 본인확인서비스 이용자간 본인확인서비스 이용에
                    필요한 고객정보를 위탁하여 본인확인서비스를 제공 하는 것에
                    대해 동의합니다.
                  </li>
                </ul>
              </li>
              <li>
                제3조 (제공정보)
                <ul class="list_type02">
                  <li>
                    - 휴대폰 본인확인서비스 제공에 필요한 개인정보로 성명,
                    휴대폰번호, 생년월일, 내·외국인구분, 성별 정보입니다.
                  </li>
                </ul>
              </li>
              <li>
                제4조 (제공받는자)
                <ul class="list_type02">
                  <li>
                    - SK텔레콤
                  </li>
                </ul>
              </li>
              <li>
                제5조 (제공기간)
                <ul class="list_type02">
                  <li>
                    - 이동통신사에서 보유중인 정보로서 별도 이용기간은 없습니다.
                  </li>
                </ul>
              </li>
              <li>
                ※ "본인"은 정보제공에 동의하지 않으실 수 있으며, 동의하지 않으실
                경우 휴대폰 본인확인서비스를 이용 하실 수 없습니다.
              </li>
            </ul>
          </div>

          <div v-else-if="ccoCd == '2' || ccoCd == '6'">
            <strong class="tit_cont_agree mgt20">[(주)케이티 귀중]</strong>
            <ul class="list_type01">
              <li>
                ((주)케이티(이하 ‘회사’라 함)가 제공하는 본인확인서비스를
                이용하기 위해, 다음과 같이 ‘회사’가 본인의 개인정보를 수집 및
                이용하고, 개인정보의 취급을 위탁하는 것에 동의합니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>
                1. 수집항목
                <ul class="list_type02">
                  <li>
                    - 이용자가 가입한 이동통신사, 휴대폰번호, 성명, 성별,
                    생년월일, 내/외국인 구분
                  </li>
                  <li>- 연계정보(CI), 중복가입확인정보(DI)</li>
                  <li>
                    - 이용자가 본인확인을 요청한 서비스명 및 URL정보, 본인확인
                    이용일시, IP 주소
                  </li>
                </ul>
              </li>
              <li>
                2. 이용목적
                <ul class="list_type02">
                  <li>
                    - 인터넷사업자의 서비스(회원가입, ID/PW찾기 등) 이용에
                    필요한 이용자 본인확인 여부 및 정보 전달 <br />(※ 이용자가
                    본인확인을 요청한 인터넷사업자에 한합니다.)
                  </li>
                  <li>
                    - (주)케이티 등 이동통신사에 이용자 정보를 전송하여 본인확인
                    및 휴대폰 정보의 일치 여부 확인
                  </li>
                  <li>- 휴대폰 사용자 확인을 위한 SMS 인증번호 전송</li>
                  <li>- 부정 이용 방지 및 수사의뢰</li>
                  <li>- 이용자 본인 요청에 의한 본인확인 이력정보 제공</li>
                  <li>
                    - 휴대폰번호보호서비스 가입여부 확인(서비스 가입자에 한함)
                  </li>
                </ul>
              </li>
              <li>3. 개인정보의 보유 및 이용기간</li>
              <li>
                "회사"는 이용자의 개인정보를 이용목적이 달성되거나 보유 및
                보존기간이 종료하면 해당 정보를 지체없이 파기 하며 별도의 보관을
                하지 않습니다. 단, 관련 법령 및 회사방침에 따라 보존하는 목적과
                기간은 아래와 같습니다.
                <ul class="list_type02">
                  <li>
                    - 소비자의 불만 또는 분쟁처리에 관한 기록 :
                    3년(전자상거래등에서의 소비자보호에 관한 법률)
                  </li>
                </ul>
              </li>
              <li>
                4. 본인확인서비스 제공을 위한 개인정보의 취급 위탁
                <ul class="list_type02">
                  <li>- 수탁자 : NICE평가정보</li>
                  <li>
                    - 취급위탁 업무 : 본인확인정보의 정확성 여부 확인,
                    연계정보(CI) 및 중복가입확인정보(DI) 전송, 서비스 관련 상담
                    및 불만 처리 등
                  </li>
                </ul>
              </li>
              <li>
                5. 상기 개인정보 수집 및 이용과 취급위탁에 동의하지 않는 경우,
                서비스를 이용할 수 없습니다.
              </li>
              <li>
                ‘회사’가 제공하는 서비스의 개인정보 취급과 관련된 사항은 아래의
                ‘회사’ 홈페이지에 기재된 개인정보취급방침에 따릅니다.
                <br />-(주)케이티 : www.kt.com
              </li>
              <li>본인은 상기 내용을 숙지하였으며 이에 동의합니다.</li>
            </ul>

            <strong class="tit_cont_agree">[NICE평가정보(주) 귀중]</strong>
            <ul class="list_type01">
              <li>
                NICE평가정보(주)(이하 ‘회사’)는 (주)케이티의 업무를 대행하여
                휴대폰본인확인서비스를 제공함에 있어 고객으로부터 개인정보를
                수집하고 이용하기 위해 ‘정보통신망 이용촉진 및 정보보호에 관한
                법률’에 따라서 다음과 같이 본인의 동의를 받습니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>1. 개인정보의 내용</li>
              <li>
                가. 정보항목
                <ul class="list_type02">
                  <li>
                    - 생년월일, 성명, 성별, 내/외국인 구분, 휴대폰번호, 가입한
                    이동통신사, IP주소
                  </li>
                </ul>
              </li>
              <li>
                나. 수집방법
                <ul class="list_type02">
                  <li>
                    - 본인인증 요청시 회원사 서비스 페이지 또는 본인인증 팝업창
                    페이지에서 이용자가 직접 입력
                  </li>
                  <li>
                    - 본인인증 과정에서 시스템에서 생성되는 정보 수집(Ex.
                    IP주소)
                  </li>
                </ul>
              </li>
              <li>2. 개인정보의 이용목적과 제공정보</li>
              <li>
                가. 이용 목적
                <ul class="list_type02">
                  <li>
                    - 고객의 회원가입, ID/PW찾기, 거래동의 등을 위한 휴대폰
                    본인확인 결과
                  </li>
                  <li>- 휴대폰 소지 확인을 위한 SMS 인증번호 전송</li>
                  <li>- 부정 이용 방지 및 수사의뢰</li>
                  <li>- 휴대폰번호보호서비스 해제(서비스 가입자에 한함)</li>
                  <li>- 기타 법률에서 정한 목적</li>
                </ul>
              </li>
              <li>
                나. 제공하는 개인정보
                <ul class="list_type02">
                  <li>
                    - 성명, 성별, 생년월일, 내/외국인, 휴대폰번호, 이동통신사,
                    IP주소, CI, DI [제공사 : 서비스회원사(업체별 선택 및
                    이용방식에 따라 전부 또는 일부를 제공)]
                  </li>
                  <li>
                    - 성명, 성별, 생년월일, 휴대폰번호, 이동통신사 [제공사 :
                    SKT, KT, LGU+]
                  </li>
                  <li>
                    - 휴대폰번호 [제공사 : SKT, KT, LGU+]
                  </li>
                </ul>
              </li>
              <li>3. 개인정보의 보유 및 이용기간</li>
              <li>
                이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이
                달성되면 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래의
                이유로 명기한 기간 동안 보유합니다.
              </li>
              <li>
                가. 회사 내부 방침에 의한 정보보유 사유 - 본인확인 발생 및
                차단기록, 휴대폰번호
                <ul class="list_type02">
                  <li>- 보유 이유: 부정 이용 방지 및 민원 처리</li>
                  <li>- 보유 기간: 1년</li>
                </ul>
              </li>
              <li>
                나. 관계법령에 의한 정보보유 사유
                <ul class="list_type02">
                  <li>- 이용자 불만 또는 분쟁 처리에 관한 기록</li>
                  <li>
                    - 보유 이유: 전자상거래 등에서의 소비자보호에 관한 법률
                  </li>
                  <li>- 보유 기간: 3년</li>
                </ul>
              </li>
            </ul>
          </div>

          <div v-if="ccoCd == '6'">
            <strong class="tit_cont_agree">[개인정보 제3자 제공 동의]</strong>
            <ul class="list_type01">
              <li>
                "알뜰폰(MVNO)"사업자는 다음과 같이 개인정보를 제3자에게 제공하고
                있습니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>
                제1조 (알뜰폰(MVNO) 사업자)
                <ul class="list_type02">
                  <li>
                    - ㈜케이티의 알뜰폰(MVNO) 사업자 (주)LG헬로비전(헬로모바일),
                    (주)니즈텔레콤(니즈모바일), (주)더원플랫폼(아이플러스유),
                    (주)미니게이트(M2모바일), (주)스테이지파이브(핀플레이),
                    (주)와이엘랜드(여유알뜰폰), (주)위너스텔(웰),
                    (주)파인디지털, (주)한국케이블텔레콤(티플러스),
                    ACN코리아(플래시모바일), KT스카이라이프(스카이라이프모바일),
                    KT엠모바일(KtM 모바일), KT텔레캅, 드림라인(주)(드림모바일),
                    로카모빌리티(주), 토스모바일(주), 아이디스파워텔㈜,
                    앤알커뮤니케이션(앤텔레콤), 에스원(안심모바일), 장성모바일,
                    ㈜세종텔레콤(스노우맨), ㈜씨엔커뮤니케이션(씨앤컴),
                    ㈜아이즈비전(아이즈모바일), ㈜에넥스텔레콤(A모바일),
                    ㈜에이프러스(아시아모바일), ㈜유니컴즈(모빙), ㈜제이씨티,
                    ㈜코드모바일(이지모바일), ㈜큰사람커넥트(이야기모바일),
                    ㈜프리텔레콤(프리티), 한국피엠오(주)(밸류컴), (주)스마텔,
                    KB국민은행(리브엠) 은 본인확인서비스의 제공을 위해 아래와
                    같이 이용자의 개인정보를 제3자에게 제공합니다
                  </li>
                </ul>
              </li>
              <li>
                제2조 (제공목적)
                <ul class="list_type02">
                  <li>
                    - 본인확인서비스 제공
                  </li>
                </ul>
              </li>
              <li>
                제3조 (제공정보)
                <ul class="list_type02">
                  <li>
                    - 성명, 휴대폰번호, 생년월일, 내 외국인구분, 성별
                  </li>
                </ul>
              </li>
              <li>
                제4조 (제공받는자)
                <ul class="list_type02">
                  <li>
                    - 주식회사 케이티(KT)
                  </li>
                </ul>
              </li>
              <li>
                제5조 (제공기간)
                <ul class="list_type02">
                  <li>
                    - 서비스 제공 완료시까지
                  </li>
                </ul>
              </li>
              <li>
                ※ '본인'은 정보제공에 동의하지 않으실 수 있으며, 동의하지 않으실
                경우 휴대폰 본인확인서비스를 이용하실 수 없습니다.
              </li>
            </ul>
          </div>

          <div v-else-if="ccoCd == '3' || ccoCd == '7'">
            <strong class="tit_cont_agree mgt20">[LG유플러스(주) 귀중]</strong>
            <ul class="list_type01">
              <li>
                LG유플러스(주) (이하 ‘회사’라 함)가 제공하는 본인확인서비스를
                이용하기 위해, 다음과 같이 ‘회사’가 본인의 개인정보를 수집 및
                이용하고, 개인정보의 취급을 위탁하는 것에 동의합니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>
                1. 수집항목
                <ul class="list_type02">
                  <li>
                    - 고객의 생년월일, 이동전화번호, 성명, 성별, 내/외국인 구분
                  </li>
                  <li>- 연계정보(CI), 중복가입확인정보(DI)</li>
                  <li>- 고객이 이용하는 웹사이트 등</li>
                </ul>
              </li>
              <li>
                2. 이용목적
                <ul class="list_type02">
                  <li>
                    - 고객이 웹사이트 또는 Application 등에 입력한
                    본인확인정보의 정확성 여부 확인
                  </li>
                  <li>
                    - 해당 웹사이트 또는 Application 등에 연계정보(CI)와
                    중복가입확인정보(DI) 전송
                  </li>
                  <li>- 서비스 관련 상담 및 불만 처리 등</li>
                  <li>- 기타 법룰에서 정한 목적</li>
                </ul>
              </li>
              <li>
                3. 개인정보의 보유 및 이용기간
                <ul class="list_type02">
                  <li>
                    - 고객이 서비스를 이용하는 기간에 한하여 보유 및 이용을
                    원칙으로 하되, 법률에서 정하는 경우 해당 기간까지 보유 및
                    이용(세부사항은 ‘회사’의 개인정보처리방침에 따름)
                  </li>
                </ul>
              </li>
              <li>
                4. 본인확인서비스 제공을 위한 개인정보의 취급 위탁
                <table
                  width="100%"
                  style="margin-top:5px;font-size: 1em; border: 1px solid rgb(221, 221, 221); border-image: none;"
                  cellspacing="0"
                  cellpadding="0"
                  summary="본인확인서비스 제공을 위한 개인정보 취급 수탁자별 위탁업무내용에 관한 테이블"
                >
                  <caption
                    style="position:absolute;top:-5000px;left:-5000px;margin:0;padding:0;font-size:0px;line-height:0;width:0;height:0;overflow:hidden;color:transparent;"
                  >
                    본인확인서비스 제공을 위한 개인정보 취급 수탁자별
                    위탁업무내용에 관한 테이블
                  </caption>
                  <colgroup>
                    <col width="50%" />
                    <col width="*" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th
                        style="padding: 5px; border-right: 1px solid #bbb; border-bottom: 1px solid #fff; background: #E8E8E8; text-align: center;"
                        scope="col"
                      >
                        수탁자
                      </th>
                      <th
                        style="padding: 5px; background: #E8E8E8; border-bottom: 1px solid #fff; text-align: center;"
                        scope="col"
                      >
                        위탁업무내용
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style="border-right: 1px solid #D2D2D2; border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        NICE평가정보(주)
                      </td>
                      <td
                        style="border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        본인확인 서비스 중계 업무 제공
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="border-right: 1px solid #D2D2D2; border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        CS리더, LB휴넷, 아이알링크 주식회사, (주)씨에스원파트너
                      </td>
                      <td
                        style="border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        고객센터 운영
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="border-right: 1px solid #D2D2D2; border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        미디어로그
                      </td>
                      <td
                        style="border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        PASS 어플리케이션 및 웹사이트 운영/관리
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="border-right: 1px solid #D2D2D2; border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        아톤
                      </td>
                      <td
                        style="border-bottom: 1px solid #D2D2D2; padding: 10px 10px;"
                      >
                        PASS 서비스 장애 및 VOC 처리
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                5. 위 개인정보 수집·이용 및 취급위탁에 동의하지 않으실 경우,
                서비스를 이용하실 수 없습니다.
              </li>
              <li>
                ‘회사’가 제공하는 서비스의 개인정보 취급과 관련된 사항은 아래의
                ‘회사’ 홈페이지에 기재된 개인정보취급방침에 따릅니다.
                <br />-LG유플러스(주) : www.lguplus.co.kr
              </li>
              <li>본인은 상기 내용을 숙지하였으며 이에 동의합니다.</li>
            </ul>

            <strong class="tit_cont_agree">[NICE평가정보(주) 귀중]</strong>
            <ul class="list_type01">
              <li>
                NICE평가정보(주)(이하 ‘회사’)는 LG유플러스(주) 의 업무를
                대행하여 휴대폰본인확인서비스를 제공함에 있어 고객으로부터
                개인정보를 수집하고 이용하기 위해 ‘정보통신망 이용촉진 및
                정보보호에 관한 법률’에 따라서 다음과 같이 본인의 동의를
                받습니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>1. 개인정보의 내용</li>
              <li>
                가. 정보항목
                <ul class="list_type02">
                  <li>
                    - 생년월일, 성명, 성별, 내/외국인 구분, 휴대폰번호, 가입한
                    이동통신사, IP주소
                  </li>
                </ul>
              </li>
              <li>
                나. 수집방법
                <ul class="list_type02">
                  <li>
                    - 본인인증 요청시 회원사 서비스 페이지 또는 본인인증 팝업창
                    페이지에서 이용자가 직접 입력
                  </li>
                  <li>
                    - 본인인증 과정에서 시스템에서 생성되는 정보 수집(Ex.
                    IP주소)
                  </li>
                </ul>
              </li>
              <li>2. 개인정보의 이용목적과 제공정보</li>
              <li>
                가. 이용 목적
                <ul class="list_type02">
                  <li>
                    - 고객의 회원가입, ID/PW찾기, 거래동의 등을 위한 휴대폰
                    본인확인 결과
                  </li>
                  <li>- 휴대폰 소지 확인을 위한 SMS 인증번호 전송</li>
                  <li>- 부정 이용 방지 및 수사의뢰</li>
                  <li>- 휴대폰번호보호서비스 해제(서비스 가입자에 한함)</li>
                  <li>- 기타 법률에서 정한 목적</li>
                </ul>
              </li>
              <li>
                나. 제공하는 개인정보
                <ul class="list_type02">
                  <li>
                    - 성명, 성별, 생년월일, 내/외국인, 휴대폰번호, 이동통신사,
                    IP주소, CI, DI [제공사 : 서비스회원사(업체별 선택 및
                    이용방식에 따라 전부 또는 일부를 제공)]
                  </li>
                  <li>
                    - 성명, 성별, 생년월일, 휴대폰번호, 이동통신사 [제공사 :
                    SKT, KT, LGU+]
                  </li>
                  <li>
                    - 휴대폰번호 [제공사 : SKT, KT, LGU+]
                  </li>
                </ul>
              </li>
              <li>3. 개인정보의 보유 및 이용기간</li>
              <li>
                이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이
                달성되면 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래의
                이유로 명기한 기간 동안 보유합니다.
              </li>
              <li>
                가. 회사 내부 방침에 의한 정보보유 사유 - 본인확인 발생 및
                차단기록, 휴대폰번호
                <ul class="list_type02">
                  <li>- 보유 이유: 부정 이용 방지 및 민원 처리</li>
                  <li>- 보유 기간: 1년</li>
                </ul>
              </li>
              <li>
                나. 관계법령에 의한 정보보유 사유
                <ul class="list_type02">
                  <li>- 이용자 불만 또는 분쟁 처리에 관한 기록</li>
                  <li>
                    - 보유 이유: 전자상거래 등에서의 소비자보호에 관한 법률
                  </li>
                  <li>- 보유 기간: 3년</li>
                </ul>
              </li>
            </ul>
          </div>

          <div v-if="ccoCd == '7'">
            <strong class="tit_cont_agree">[개인정보 제3자 제공 동의]</strong>
            <ul class="list_type01">
              <li>
                "알뜰폰(MVNO)"사업자는 다음과 같이 개인정보를 제3자에게 제공하고
                있습니다.
              </li>
            </ul>

            <ul class="list_type01">
              <li>
                제1조 (알뜰폰(MVNO) 사업자)
                <ul class="list_type02">
                  <li>
                    - 엘지유플러스의 알뜰폰(MVNO) 사업자는 인스코비(프리티),
                    토스모바일(주), (주)엠티티텔레콤(메리큐),
                    (주)미디어로그(U+유모바일), 이마트, 서경방송, 울산방송,
                    푸른방송, 남인천방송, 금강방송, 제주방송,
                    (주)와이엘랜드(여유텔레콤), ACN코리아(플래시모바일),
                    이지모바일, 유니컴즈(모빙), 큰사람(이야기), 스마텔,
                    에넥스텔레콤(A모바일), 레그원(온국민폰),
                    드림에이치앤비(셀모바일), 조이텔(조이텔),
                    에스원(안심모바일), 원텔레콤, (주)국민은행(Liiv M),
                    LG헬로비전(헬로모바일), 엔티온텔레콤, 인스모바일,
                    아시아모바일, 슈가모바일, 코나아이 입니다.
                  </li>
                </ul>
              </li>
              <li>
                제2조 (제공목적)
                <ul class="list_type02">
                  <li>
                    - 본 동의는 본인확인 서비스를 제공하기 위하여 본인확인기관인
                    (주)엘지유플러스와 본인확인서비스 이용자간<br />
                    본인확인서비스 이용에 필요한 고객정보를 위탁하여
                    본인확인서비스를 제공 하는 것에 대해 동의합니다.
                  </li>
                </ul>
              </li>
              <li>
                제3조 (제공정보)
                <ul class="list_type02">
                  <li>
                    - 휴대폰 본인확인 서비스 제공에 필요한 개인정보로 성명,
                    휴대폰번호, 생년월일, 내·외국인구분, 성별 정보입니다.
                  </li>
                </ul>
              </li>
              <li>
                제4조 (제공받는자)
                <ul class="list_type02">
                  <li>
                    - (주)엘지유플러스
                  </li>
                </ul>
              </li>
              <li>
                제5조 (제공기간)
                <ul class="list_type02">
                  <li>
                    - 이동통신사에서 보유중인 정보로서 별도 이용기간은 없습니다.
                  </li>
                </ul>
              </li>
              <li>
                ※ '본인'은 정보제공에 동의하지 않으실 수 있으며, 동의하지 않으실
                경우 휴대폰 본인확인서비스를 이용하실 수 없습니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="popbox_btn">
        <div>
          <button type="button" class="btn color1" @click="$emit('close')">
            확인
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IndvInfUseNdOfrAgr',
  props: {
    ccoCd: String,
  },
}
</script>
